import styled from 'styled-components';
import { boxShadow1 } from 'utils/style/colors';

export const Config = styled('div')`
  @media print {
    display: none;
  }
`;
export const Container = styled('div')`
  display: grid;
  grid-auto-flow: dense;
  grid-auto-rows: 200px;
  grid-template-columns: repeat(6, 1fr);
  gap: 10px;
`;
export const SimpleContainer = styled('div')`
  //display: grid;
  //grid-auto-flow: dense;
  //grid-auto-rows: 200px;
  //grid-template-columns: repeat(6, 1fr);
  //gap: 10px;
`;

export const Item = styled('div')`
  page-break-after: always;
  display: block;
  position: relative;
  border-radius: 10px;
  background-color: var(--exact-white);
  box-shadow: ${boxShadow1};
  overflow: hidden;
  width: 100%;
  height: 100%;
  grid-column-end: span 1;
  grid-row-end: span 1;
  & > img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
  @media print {
    border-radius: 0;
    background-color: var(--exact-white);
    box-shadow: 0;
    margin: 0.5rem;
  }
`;
export const SimpleItem = styled('div')`
  page-break-after: always;
  & > img {
    display: block;
    page-break-before: auto;
    width: 100%;
    height: 100%;
    object-fit: contain;
    break-inside: avoid-page;
  }
  page-break-before: auto;
  break-inside: avoid-page;
  width: 100%;
  height: 100%;
`;

export const Actions = styled('div')`
  display: block;
  position: absolute;
  left: 0;
  bottom: 0;
  @media print {
    display: none;
  }
`;
